import { combineReducers } from "redux";
import cmsReducer from "./CmsReducer";

const reducers = combineReducers({
  cms: cmsReducer,
});

export default reducers;
